import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-location-routes',
  templateUrl: './location-routes.component.html',
  styleUrls: ['./location-routes.component.css']
})
export class LocationRoutesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/location-routes/location-routes.component.ts